/**
 * Public brand assets (drschoice/flow#615 Phase 4).
 *
 * Logos, cover art and the group whitepaper PDFs are the only objects in the
 * doctorschoice bucket that are meant to be world-readable. Everything else is
 * being made private, and Public Access Block can't go on until these move to
 * a bucket/CDN of their own — so they're addressed through a configurable base
 * rather than a hardcoded bucket URL.
 *
 * These now live in `doctorschoice-public-assets`, a bucket whose only job is
 * serving them: ACLs are disabled entirely and anonymous read comes from a
 * bucket policy scoped to s3:GetObject (no listing). That separation is what
 * lets Public Access Block go on the `doctorschoice` bucket, which holds the
 * client documents.
 *
 * Swap this constant (or pass an explicit base) to move the assets again, e.g.
 * behind CloudFront on a doctorschoiceusa.com subdomain.
 */
export const DEFAULT_ASSETS_BASE = 'https://doctorschoice-public-assets.s3.amazonaws.com'

export function assetUrl (assetPath, base = DEFAULT_ASSETS_BASE) {
    const cleanBase = (base || DEFAULT_ASSETS_BASE).replace(/\/+$/, '')
    const cleanPath = String(assetPath || '').replace(/^\/+/, '')
    return `${cleanBase}/${cleanPath}`
}
